// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-container {
    padding: 20px;
  }
  
  .register-container h2 {
    margin-bottom: 20px;
  }
  
  .request-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .request-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 8px;
  }
  
  .request-info {
    flex: 1 1;
  }
  
  .btn {
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 10px;
  }
  
  .btn.view {
    background-color: #007bff;
    color: white;
  }
  
  .btn.accept {
    background-color: #28a745;
    color: white;
  }
  
  .btn.ignore {
    background-color: #dc3545;
    color: white;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/register.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd","sourcesContent":[".register-container {\n    padding: 20px;\n  }\n  \n  .register-container h2 {\n    margin-bottom: 20px;\n  }\n  \n  .request-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .request-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #f8f9fa;\n    padding: 15px;\n    border-radius: 8px;\n  }\n  \n  .request-info {\n    flex: 1;\n  }\n  \n  .btn {\n    padding: 8px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-left: 10px;\n  }\n  \n  .btn.view {\n    background-color: #007bff;\n    color: white;\n  }\n  \n  .btn.accept {\n    background-color: #28a745;\n    color: white;\n  }\n  \n  .btn.ignore {\n    background-color: #dc3545;\n    color: white;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
